import 'custom-event-polyfill';
import 'svg4everybody';
import initCommon from './Common/index';
import initRoutes from './Routes/index';

if (
	// ES2016
	!Array.prototype.includes
	// ES2015
	|| !(window as any).WeakSet
	|| !(window as any).Symbol
	|| !Array.from
	|| !Object.assign
)
{
	import ( /* webpackChunkName: "core-js" */ 'core-js/shim' )
		.then( app );
}
else
{
	app();
}

function app(): void
{
	initCommon();
	initRoutes();
}



// WEBPACK FOOTER //
// ./app/index.ts